import jwt_decode from 'jwt-decode';
import store from 'store2';
import { LocalStorageKey } from '../enums';
import { getUnixTime, isCSR, isLocalEnv } from './env';
export const getAccessToken = () => {
    var _a;
    if (!isCSR())
        return;
    try {
        const token = (_a = store(LocalStorageKey.AUTH_TOKEN)) === null || _a === void 0 ? void 0 : _a.access_token;
        return jwt_decode(token);
    }
    catch (error) {
        console.error(error);
    }
    return;
};
export const getTokenExpirationTime = () => {
    try {
        if (isLocalEnv())
            return getUnixTime(4 * 60 - 20);
        const token = getAccessToken();
        if (token)
            return token.exp;
    }
    catch (error) {
        console.error(error);
    }
    return 0;
};
export const getTokenIssuanceTime = () => {
    try {
        if (isLocalEnv())
            return getUnixTime(-20);
        const token = getAccessToken();
        if (token)
            return token.iat;
    }
    catch (error) {
        console.error(error);
    }
    return 0;
};
export const getAuthTimeDiff = () => {
    var _a;
    if (isLocalEnv())
        return getUnixTime(-getTokenIssuanceTime());
    return (_a = store(LocalStorageKey.AUTH_TIME_DIFF)) !== null && _a !== void 0 ? _a : 0;
};
export const isAuthenticated = () => {
    const token = getAccessToken();
    if (!token || token.exp < getUnixTime() - getAuthTimeDiff())
        return false;
    return true;
};
/**
 * Get the current session lifespan in minutes
 *
 * It subtracts the token's `issuance-time` from the token's `expiration-time`
 */
export const getSessionLifespan = () => {
    try {
        const sessionTime = getTokenExpirationTime() - getTokenIssuanceTime();
        return Math.trunc(sessionTime / 60);
    }
    catch (error) {
        console.error(error);
    }
    return 5;
};
export const getRefreshToken = () => {
    const authToken = store(LocalStorageKey.AUTH_TOKEN);
    return authToken === null || authToken === void 0 ? void 0 : authToken.refresh_token;
};
//# sourceMappingURL=auth.js.map